export const authenticationMethodTypesMap = {
  INTERNAL: 1,
  LDAP: 2,
  OAUTH: 3,
};

export const authenticationMethodTypesLabels = {
  [authenticationMethodTypesMap.INTERNAL]: 'Internal',
  [authenticationMethodTypesMap.LDAP]: 'LDAP',
  [authenticationMethodTypesMap.OAUTH]: 'OAuth',
};
